function setParam(url, name, value) {
    if (url.searchParams.has(name)) {
        url.searchParams[name] = value;
    } else {
        url.searchParams.append(name, value);
    }
}

// eslint-disable-next-line import/prefer-default-export
export function autoWebp(image) {
    if (image == null) {
        return image;
    }

    const img = image.startsWith('//') ? `https:${image}` : image;

    try {
        const url = new URL(img);

        setParam(url, 'fmt', 'webp-auto');
        setParam(url, 'qlt', '75');

        return url.toString();
    } catch (e) {
        // Nothing.
    }

    return image;
}
